import moment from 'moment';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
	Box,
	Card,
	CardHeader,
	Divider,
	Table,
	TableBody,
	TableCell,
	Link,
	TableHead,
	TableRow,
} from '@material-ui/core';
import { useSelector, shallowEqual } from 'react-redux';
import { PayStatus } from '../common';
import { getPlanData } from '../../utils';

const LatestOrders = () => {
	const {
		state,
		planId,
		invoiceUrl,
		paidAt,
		loading,
	} = useSelector((_state) => _state.subscription, shallowEqual);

	const plan = getPlanData(state, planId);

	return (
		!(loading || state === 'free') && (
			<Card sx={{ 'overflow-x': 'auto' }}>
				<CardHeader title="Last payment" />
				<Divider />
				<PerfectScrollbar>
					<Box sx={{ minWidth: 800 }}>
						<Table>
							<TableHead>
								<TableRow>
									<TableCell align="center">Plan</TableCell>
									<TableCell align="center">Sum</TableCell>
									<TableCell align="center">Limit</TableCell>
									<TableCell align="center">Biling date</TableCell>
									<TableCell align="center">Status</TableCell>
									<TableCell align="center">Link</TableCell>
								</TableRow>
							</TableHead>
							<TableBody>
								<TableRow hover key={planId}>
									<TableCell align="center">{plan?.title}</TableCell>
									<TableCell align="center">${plan?.price}</TableCell>
									<TableCell align="center">{plan?.numberOfTracks}</TableCell>
									<TableCell align="center">{moment(paidAt).format('hh:mm, DD MMMM YYYY')}</TableCell>
									<TableCell align="center">
										<PayStatus status={state} />
									</TableCell>
									<TableCell align="center">
										<Link target="_blank" href={invoiceUrl} rel="noreferrer" color="primary">
											Invoice
										</Link>
									</TableCell>
								</TableRow>
							</TableBody>
						</Table>
					</Box>
				</PerfectScrollbar>
			</Card>
		)
	);
};

export default LatestOrders;
